/**
 * key : 'VUE_APP_COMPANY_ID'
 *  - router
 *    - model [一个页面可能存在多个COMPONENTS] 对应 SpComponent 组件 的 myName 属性 以及对应的 handle;
 */
import innisfree from './innisfree/config'
import dreamW from './DW/config'
import { importAll } from '@/utils'

const installs = {}
importAll(require.context('./', true, /index\.js$/), (key, r) => {
  const keyPath = key.match(/\.\/(.+)\.js$/)[1]
  if (!['index'].includes(keyPath)) {
    installs[keyPath] = r(key).default.install
  }
})

export const COMPONENTS_ROUTER_LIST = {
  '777': innisfree,
  '666': dreamW
}

export default installs
